import { FooterImage, TinyLogoImage } from "../styles/Images";
import { TickerText } from "../styles/Typography";
import { TickerInner } from "../styles/Layouts";

const Footer = () => {
  const repeatedText = "locally brewed culture. served daily ";
  const tickerItems = Array(16).fill(repeatedText);

  return (
    <FooterImage>
      <TickerInner>
        {tickerItems.map((text, index) => (
          <TickerText key={index}>
            {repeatedText}
            <TinyLogoImage />
          </TickerText>
        ))}
      </TickerInner>
    </FooterImage>
  );
};

export default Footer;
